/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { useApp } from '@/provider/app';

const useDepartment = () => {
  const app = useApp();

  const department = app.currentDepartment;
  return {
    department,
    error: app?.error,
    departmentId: app?.departmentId
  };
};

export default useDepartment;
